export const messages = {
    en: {
      moreShop: {
        title: 'Switch Shop',
        searchPlaceholder: 'Enter shop name',
        shopId: 'Shop ID',
        shopName: 'Shop Name',
        address: 'Address',
        fetchError: 'Failed to load shop data',
        operation: 'Operation'
      }
    },
    zh: {
      moreShop: {
        title: '切换商铺',
        searchPlaceholder: '输入商铺名称',
        shopId: '商铺ID',
        shopName: '商铺名称',
        address: '地址',
        fetchError: '加载商铺数据失败',
        operation: '操作'
      }
    }
  }